function asm_create_cookie(name, value, expires, path, domain, secure) {
  var today = new Date();
  today.setTime(today.getTime());
  if (expires) {
    expires = expires * 1000 * 60 * 60 * 24;
  }
  var expires_date = new Date(today.getTime() + expires);
  document.cookie =
    name +
    "=" +
    escape(value) +
    (expires ? ";expires=" + expires_date.toGMTString() : "") +
    (path ? ";path=" + path : "") +
    (domain ? ";domain=" + domain : "") +
    (secure ? ";secure" : "");
}
function asm_read_cookie(check_name) {
  var i,
    x,
    y,
    ARRcookies = document.cookie.split(";");
  for (i = 0; i < ARRcookies.length; i++) {
    x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
    y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
    x = x.replace(/^\s+|\s+$/g, "");
    if (x == check_name) {
      return unescape(y);
    }
  }
}
function asm_alt_cart(cart_type) {
  var alt_cart_init = "";
  var alt_cart_ship_rate = "N/A";
  var alt_cart_tax_rate = "TBD";
  if (cart_type == "error") {
    alt_cart_init = "There are no shipping rates for your shopping cart";
    alt_cart_ship_rate = "TBD";
    alt_cart_tax_rate = "TBD";
  } else if (cart_type == "empty") {
    alt_cart_init = "Your cart is currently empty";
    alt_cart_ship_rate = "N/A";
    alt_cart_tax_rate = "N/A";
  }
  if (document.getElementById("asm-methods-init"))
    document.getElementById("asm-methods-init").innerHTML = alt_cart_init;
  if (document.getElementById("asm-subtotal-rate"))
    document.getElementById("asm-subtotal-rate").innerHTML =
      "$" + asm_cart_subtotal;
  if (document.getElementById("asm-shipping-rate"))
    document.getElementById("asm-shipping-rate").innerHTML = alt_cart_ship_rate;
  if (document.getElementById("asm-tax-rate"))
    document.getElementById("asm-tax-rate").innerHTML = alt_cart_tax_rate;
  if (document.getElementById("asm-total-rate"))
    document.getElementById("asm-total-rate").innerHTML = "$" + asm_cart_total;
  document.getElementById("asm-mini-cart").style.opacity = "1";
}
function asm_calc_totals() {
  var subtotal = 0;
  var shipping = 0;
  var tax = 0;
  var total = 0;
  var discount = 0;
  if (document.getElementById("asm-subtotal-rate"))
    subtotal = parseFloat(
      document.getElementById("asm-subtotal-rate").innerHTML.replace("$", ""),
    );
  if (document.getElementById("asm-method-1")) {
    if (document.getElementById("asm-shipping-rate")) {
      if (
        document
          .getElementById("asm-shipping-rate")
          .innerHTML.indexOf("FREE") != -1
      ) {
        shipping = parseFloat("0.00");
      } else {
        shipping = parseFloat(
          document
            .getElementById("asm-shipping-rate")
            .innerHTML.replace("$", ""),
        );
      }
    }
  } else {
    shipping = 0;
  }
  if (asm_total_discount) {
    discount = asm_total_discount / 100;
  }

  total = (subtotal * 10 + shipping * 10 + tax * 10 - discount * 10) / 10;
  total = total.toFixed(2);
  if (document.getElementById("asm-total-rate") && total)
    document.getElementById("asm-total-rate").innerHTML = "$" + total;
  if (discount > 0 && document.getElementById("asm-discounts")) {
    document.getElementById("asm-discounts").open = true;
  }
}
function asm_select_shipping_methods(method_position, total_positions) {
  for (i = 1; i <= total_positions; i++) {
    if (i == method_position) {
      if (document.getElementById("asm-method-" + method_position)) {
        document
          .getElementById("asm-method-" + method_position)
          .getElementsByTagName("input")[0].checked = true;
        if (
          document
            .getElementById("asm-method-" + method_position)
            .className.indexOf("asm-shipping-method-selected") == -1
        )
          document
            .getElementById("asm-method-" + method_position)
            .classList.add("asm-shipping-method-selected");
        if (document.getElementById("asm-shipping-rate"))
          document.getElementById("asm-shipping-rate").innerHTML = document
            .getElementById("asm-method-" + method_position)
            .getElementsByTagName("div")[2].innerHTML;
        asm_calc_totals();
      }
    } else {
      if (document.getElementById("asm-method-" + i)) {
        if (
          document
            .getElementById("asm-method-" + i)
            .className.indexOf("asm-shipping-method-selected") != -1
        )
          document
            .getElementById("asm-method-" + i)
            .classList.remove("asm-shipping-method-selected");
      }
    }
  }
}
function asm_save_method(selected_method, method_value) {
  asm_selected_method = selected_method;
  sessionStorage.setItem("ASM-Selected-Method", asm_selected_method);
}
function asm_parse_mini_cart_methods(shipping_rates) {
  var shipping_methods = JSON.parse(shipping_rates);
  var results = "";
  var selected_number = "";
  var tmp_method_name_display = "";
  var tmp_method_desc_display = "";
  if (
    shipping_methods.shipping_rates &&
    shipping_methods.shipping_rates.length > 0
  ) {
    for (i = 0; i < shipping_methods.shipping_rates.length; i++) {
      var x = i + 1;
      if (
        shipping_methods.shipping_rates[i].name != "" &&
        shipping_methods.shipping_rates[i].price != ""
      ) {
        if (asm_selected_method == shipping_methods.shipping_rates[i].name)
          selected_number = x;
        tmp_method_name_display = shipping_methods.shipping_rates[
          i
        ].name.replace(" (", '<div class="asm-cart-method-note">(');
        tmp_method_name_display = tmp_method_name_display.replace(
          ")",
          ")</div>",
        );
        results =
          results +
          '<div id="asm-method-' +
          x +
          '" class="asm-shipping-method" onclick="asm_select_shipping_methods(' +
          x +
          ", " +
          shipping_methods.shipping_rates.length +
          ');">';
        results = results + '	<div class="asm-method-radio-button-holder">';
        results = results + "		<label>";
        results =
          results +
          '			<input type="radio" name="asm-selected-shipping-method" checked onclick="asm_save_method (\'' +
          shipping_methods.shipping_rates[i].name +
          "', " +
          shipping_methods.shipping_rates[i].price +
          ');" />';
        results = results + "			<span></span>";
        results = results + "		</label>";
        results = results + "	</div>";
        results = results + '	<div class="asm-method-info">';
        if (
          shipping_methods.shipping_rates[i].price == "0.00" &&
          asm_fake_standard_rate > 0 &&
          tmp_method_name_display.toLowerCase().indexOf("call us") != -1 &&
          tmp_method_name_display.toLowerCase().indexOf("quote") == -1
        )
          results =
            results +
            '		<div class="asm-cart-method-rate"><span>$' +
            asm_fake_standard_rate +
            '</span><em class="asm-free-rate">CALL US</em></div>';
        else if (
          shipping_methods.shipping_rates[i].price == "0.00" &&
          asm_fake_standard_rate > 0 &&
          tmp_method_name_display.toLowerCase().indexOf("call us") == -1 &&
          tmp_method_name_display.toLowerCase().indexOf("quote") != -1
        )
          results =
            results +
            '		<div class="asm-cart-method-rate"><span>$' +
            asm_fake_standard_rate +
            '</span><em class="asm-free-rate">QUOTE</em></div>';
        else if (
          shipping_methods.shipping_rates[i].price == "0.00" &&
          asm_fake_standard_rate > 0 &&
          tmp_method_name_display.toLowerCase().indexOf("call us") == -1 &&
          tmp_method_name_display.toLowerCase().indexOf("quote") == -1
        )
          results =
            results +
            '		<div class="asm-cart-method-rate"><span>$' +
            asm_fake_standard_rate +
            '</span><em class="asm-free-rate">FREE</em></div>';
        else if (
          shipping_methods.shipping_rates[i].price == "0.00" &&
          tmp_method_name_display.toLowerCase().indexOf("call us") != -1 &&
          tmp_method_name_display.toLowerCase().indexOf("quote") == -1
        )
          results =
            results +
            '		<div class="asm-cart-method-rate"><em class="asm-free-rate">CALL US</em></div>';
        else if (
          shipping_methods.shipping_rates[i].price == "0.00" &&
          tmp_method_name_display.toLowerCase().indexOf("call us") == -1 &&
          tmp_method_name_display.toLowerCase().indexOf("quote") != -1
        )
          results =
            results +
            '		<div class="asm-cart-method-rate"><em class="asm-free-rate">QUOTE</em></div>';
        else if (
          shipping_methods.shipping_rates[i].price == "0.00" &&
          tmp_method_name_display.toLowerCase().indexOf("call us") == -1 &&
          tmp_method_name_display.toLowerCase().indexOf("quote") == -1
        )
          results =
            results +
            '		<div class="asm-cart-method-rate"><em class="asm-free-rate">FREE</em></div>';
        else
          results =
            results +
            '		<div class="asm-cart-method-rate">$' +
            shipping_methods.shipping_rates[i].price +
            "</div>";
        results =
          results +
          '		<div class="asm-cart-method-name">' +
          tmp_method_name_display +
          "</div>";
        results = results + "	</div>";
        results = results + '	<div class="asm-clear-both"></div>';
        results = results + "</div>";
      }
    }
  }
  document.getElementById("asm-shipping-methods-list").innerHTML = results;
  if (selected_number != "" && 1 == 0)
    asm_select_shipping_methods(
      selected_number,
      shipping_methods.shipping_rates.length,
    );
  else asm_select_shipping_methods(1, shipping_methods.shipping_rates.length);
  document.getElementById("asm-mini-cart").style.opacity = "1";
  if (document.getElementById("asm-ship-to-city-state"))
    document.getElementById("asm-ship-to-city-state").style.display =
      "inline-block";
  if (document.getElementById("asm-ship-to-zip"))
    document.getElementById("asm-ship-to-zip").style.display = "inline-block";
  if (document.getElementById("asm-ship-to-force-zip"))
    document.getElementById("asm-ship-to-force-zip").style.display = "none";
  if (document.getElementById("asm-force-zip-apply"))
    document.getElementById("asm-force-zip-apply").innerHTML = "Apply";
}
function asm_mini_cart_shipping(zip, state, country) {
  var shipping_rates;
  var xhr = new XMLHttpRequest();
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      shipping_rates = xhr.response;
      var tmp_shipping_methods_check = JSON.parse(shipping_rates);
      if (
        shipping_rates == '{"error":["This cart does not require shipping"]}'
      ) {
        asm_alt_cart("empty");
      } else if (
        shipping_rates == '{"shipping_rates":[]}' ||
        typeof tmp_shipping_methods_check.shipping_rates == "undefined"
      ) {
        asm_alt_cart("error");
      } else {
        if (shipping_rates == "") console.log("CHECK!");
        asm_parse_mini_cart_methods(shipping_rates);
      }
    }
  };
  xhr.open(
    "GET",
    "/cart/shipping_rates.json?shipping_address[zip]=" +
      zip +
      "&shipping_address[country]=" +
      country +
      "&shipping_address[province]=" +
      state,
    true,
  );
  xhr.send();
}
function asm_search_standard_rate_value() {
  for (const [key, value] of Object.entries(standard_rates)) {
    if (parseFloat(key) <= parseFloat(asm_cart_weight_lb)) {
      asm_fake_standard_rate = value;
    } else if (parseFloat(key) > parseFloat(asm_cart_weight_lb)) {
      break;
    }
  }
}
function asm_add_insurance_item(variant_id) {
  jQuery.ajax({
    url: "/cart/add.js",
    type: "post",
    dataType: "json",
    data: {
      items: [
        {
          id: "" + variant_id + "",
          quantity: 1,
        },
      ],
    },
    success: function () {
      window.location = "/cart";
    },
    error: function () {
      console.log("ASM debug error - adding product ID " + variant_id);
      asm_ajax_counter = asm_ajax_counter + 1;
      if (asm_ajax_counter < 10) asm_add_insurance_item(variant_id);
    },
  });
}
function asm_remove_insurance_item(variant_id) {
  jQuery.ajax({
    url: "/cart/update.js",
    type: "post",
    dataType: "json",
    data: "updates[" + variant_id + "]=0",
    success: function () {
      window.location = "/cart";
    },
    error: function () {
      console.log("ASM debug error - removing product ID " + variant_id);
      asm_ajax_counter = asm_ajax_counter + 1;
      if (asm_ajax_counter < 10) asm_remove_insurance_item(variant_id);
    },
  });
}
function asm_update_insurance_item(old_variant_id, new_variant_id) {
  jQuery.ajax({
    url: "/cart/update.js",
    type: "post",
    dataType: "json",
    data: "updates[" + old_variant_id + "]=0",
    success: function () {
      jQuery.ajax({
        url: "/cart/add.js",
        type: "post",
        dataType: "json",
        data: {
          items: [
            {
              id: "" + new_variant_id + "",
              quantity: 1,
            },
          ],
        },
        success: function () {
          window.location = "/cart";
        },
      });
    },
    error: function () {
      console.log(
        "ASM debug error - updating product ID " +
          new_variant_id +
          " instead of product ID " +
          old_variant_id,
      );
      asm_ajax_counter = asm_ajax_counter + 1;
      if (asm_ajax_counter < 10)
        asm_update_insurance_item(old_variant_id, new_variant_id);
    },
  });
}
function asm_read_cart_data() {
  var cart_data;
  var xhr = new XMLHttpRequest();
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      cart_data = JSON.parse(xhr.response);
      // console.log(cart_data);

      asm_cart_subtotal = cart_data.original_total_price / 100;
      asm_cart_subtotal = asm_cart_subtotal.toFixed(2);
      asm_cart_total = cart_data.total_price / 100;
      asm_cart_total = asm_cart_total.toFixed(2);

      if (asm_cart_total > 0 && document.getElementById("asm-total-rate")) {
        document.getElementById("asm-total-rate").innerHTML =
          "$" + asm_cart_total;
      }

      if (asm_cart_subtotal > 0) {
        if (document.getElementById("asm-subtotal-rate"))
          document.getElementById("asm-subtotal-rate").innerHTML =
            "$" + asm_cart_subtotal;
        if (cart_data.items) {
          var asm_insurance_product_found = false;
          for (i = 0; i < cart_data.items.length; i++) {
            if (
              cart_data.items[i].sku == "ASM-INSURANCE" &&
              asm_insurance_product_found == false
            ) {
              asm_insurance_product_found = true;
              asm_existing_insurance = cart_data.items[i].price / 100;
              asm_existing_insurance_variant_id = cart_data.items[i].id;
              asm_insurance_product_found = true;
              if (document.getElementById("asm-toggle-insurance"))
                document.getElementById("asm-toggle-insurance").checked = true;
            } else if (
              cart_data.items[i].sku == "ASM-INSURANCE" &&
              asm_insurance_product_found == true &&
              asm_existing_insurance_variant_id != ""
            ) {
              asm_remove_insurance_item(cart_data.items[i].id);
            }
          }
        }
        asm_cart_weight_lb = cart_data.total_weight * 0.0022046;
        asm_cart_weight_lb = asm_cart_weight_lb.toFixed(2);
        if (
          asm_cookie_domain == "www.importimageracing.com" ||
          asm_cookie_domain == "dirtyoffroad.myshopify.com" ||
          asm_cookie_domain == "fashionablecanes.comX" ||
          asm_cookie_domain == "fashionablehats.comX" ||
          asm_cookie_domain == "tensunits.comX"
        ) {
          if (
            asm_insurance != asm_existing_insurance &&
            asm_existing_insurance > 0
          ) {
            asm_create_insurance_item(asm_existing_insurance_variant_id);
          } else {
          }
          document.getElementById("asm-insurance-cost").innerHTML =
            "$" + asm_insurance;
          document.getElementById("asm-insurance-option").style.display =
            "block";
        }
      }
      if (auto_calc == false) asm_force_change_zip();
    }
  };
  xhr.open("GET", "/cart.js", true);
  xhr.send();
}
function asm_create_insurance_item(old_variant_id) {
  var jsel = document.createElement("SCRIPT");
  jsel.type = "text/javascript";
  jsel.src =
    "https://www.advancedshippingmanager.com/clients/calcs/shopify_cart/minicart/asm_mini_cart.php?si=" +
    Shopify.shop.replace(".myshopify.com", "") +
    "&add_insurance=true&price=" +
    asm_insurance +
    "&ov=" +
    old_variant_id;
  document.getElementById("asm-mini-cart").appendChild(jsel);
}
function asm_toggle_rate() {
  var tmp_total = document.getElementById("asm-total-rate").innerHTML;
  if (document.getElementById("asm-toggle-insurance").checked == false) {
    asm_remove_insurance_item(asm_existing_insurance_variant_id);
  } else if (document.getElementById("asm-toggle-insurance").checked == true) {
    asm_create_insurance_item();
  }
}
function asm_mini_cart_activate_enter(evt) {
  evt = evt ? evt : event;
  var charCode = evt.charCode
    ? evt.charCode
    : evt.which
      ? evt.which
      : evt.keyCode;
  if (charCode == 13) {
    asm_ship_recalc();
    return false;
  } else {
    return true;
  }
}
function asm_ship_recalc() {
  if (document.getElementById("asm-force-zip")) {
    auto_calc = true;
    var asm_zip_code = document.getElementById("asm-force-zip").value;
    if (asm_zip_code != "") {
      if (document.getElementById("asm-force-zip-apply"))
        document.getElementById("asm-force-zip-apply").innerHTML =
          "Calculating...";
      var jsel = document.createElement("SCRIPT");
      jsel.type = "text/javascript";
      jsel.src =
        "https://www.advancedshippingmanager.com/clients/calcs/shopify_cart/minicart/asm_mini_cart.php?zip_lookup=" +
        asm_zip_code +
        "&si=" +
        Shopify.shop.replace(".myshopify.com", "");
      document.getElementById("asm-mini-cart").appendChild(jsel);
    }
  }
}
function asm_change_zip_code() {
  if (document.getElementById("asm-ship-to-change")) {
    if (document.getElementById("asm-ship-to-change").innerHTML == "CHANGE")
      document.getElementById("asm-ship-to-change").innerHTML = "CLOSE";
    else document.getElementById("asm-ship-to-change").innerHTML = "CHANGE";
  }
  if (document.getElementById("asm-ship-to-city-state")) {
    if (
      document.getElementById("asm-ship-to-city-state").style.display ==
      "inline-block"
    )
      document.getElementById("asm-ship-to-city-state").style.display = "none";
    else
      document.getElementById("asm-ship-to-city-state").style.display =
        "inline-block";
  }
  if (document.getElementById("asm-ship-to-zip")) {
    if (
      document.getElementById("asm-ship-to-zip").style.display == "inline-block"
    )
      document.getElementById("asm-ship-to-zip").style.display = "none";
    else
      document.getElementById("asm-ship-to-zip").style.display = "inline-block";
  }
  if (document.getElementById("asm-ship-to-force-zip")) {
    if (
      document.getElementById("asm-ship-to-force-zip").style.display == "none"
    )
      document.getElementById("asm-ship-to-force-zip").style.display = "flex";
    else
      document.getElementById("asm-ship-to-force-zip").style.display = "none";
  }
}
function asm_force_change_zip() {
  if (document.getElementById("asm-total-rate"))
    document.getElementById("asm-total-rate").innerHTML = "$" + asm_cart_total;
  if (document.getElementById("asm-mini-cart"))
    document.getElementById("asm-mini-cart").style.opacity = "1";
  if (document.getElementById("asm-ship-to-city-state"))
    document.getElementById("asm-ship-to-city-state").style.display =
      "inline-block";
  if (document.getElementById("asm-ship-to-zip"))
    document.getElementById("asm-ship-to-zip").style.display = "inline-block";
  if (document.getElementById("asm-ship-to-force-zip"))
    document.getElementById("asm-ship-to-force-zip").style.display = "none";
  if (document.getElementById("asm-force-zip-apply"))
    document.getElementById("asm-force-zip-apply").innerHTML = "Apply";
  asm_change_zip_code();
}
function asm_set_geo_values(city, state, zip, country) {
  var asm_geo_data = city + "~" + state + "~" + zip + "~" + country;
  sessionStorage.setItem("ASM-Geo-Data", asm_geo_data);
  if (document.getElementById("asm-ship-to-change"))
    document.getElementById("asm-ship-to-change").innerHTML = "CHANGE";
  if (document.getElementById("asm-ship-to-city-state"))
    document.getElementById("asm-ship-to-city-state").innerHTML =
      city + ", " + state;
  if (document.getElementById("asm-ship-to-zip"))
    document.getElementById("asm-ship-to-zip").innerHTML = "(" + zip + ")";
  if (document.getElementById("asm-force-zip"))
    document.getElementById("asm-force-zip").value = zip;
  if (auto_calc == true) asm_mini_cart_shipping(zip, state, country);
}
function asm_geo_location() {
  if (auto_calc == false) {
    if (document.getElementById("asm-shipping-methods-list"))
      document.getElementById("asm-shipping-methods-list").innerHTML = "";
    if (document.getElementById("asm-shipping-rate"))
      document.getElementById("asm-shipping-rate").innerHTML = "TBD";
  }
  if (sessionStorage.getItem("ASM-Geo-Data")) {
    var asm_geo_data = sessionStorage.getItem("ASM-Geo-Data");
    var asm_geo_exploded = asm_geo_data.split("~");
    var city = asm_geo_exploded[0];
    var state = asm_geo_exploded[1];
    var zip = asm_geo_exploded[2];
    var country = asm_geo_exploded[3];
    asm_set_geo_values(city, state, zip, country);
  } else {
    var jsel = document.createElement("SCRIPT");
    jsel.type = "text/javascript";
    jsel.src =
      "https://www.advancedshippingmanager.com/clients/calcs/shopify_cart/minicart/asm_mini_cart.php?si=" +
      Shopify.shop.replace(".myshopify.com", "");
    document.getElementById("asm-mini-cart").appendChild(jsel);
  }
}
function asm_add_event(obj, evType, fn) {
  if (obj.addEventListener) {
    obj.addEventListener(evType, fn, false);
    return true;
  } else if (obj.attachEvent) {
    var r = obj.attachEvent("on" + evType, fn);
    return r;
  } else {
    return false;
  }
}
function enhanceCouponAccessibility() {
  const couponInput = document.querySelector(".docapp-coupon-input--input");

  const couponButton = document.querySelector(".docapp-coupon-input--button");

  if (couponInput) {
    if (!couponInput.id) {
      couponInput.id = "cart-coupon-code";
    }

    const existingLabel = document.querySelector(
      'label[for="cart-coupon-code"]',
    );

    const originalCouponInputs = document.querySelectorAll(
      'input.docapp-replaces[placeholder="Coupon Code"]',
    );

    originalCouponInputs.forEach((input) => {
      if (!input.hasAttribute("aria-label")) {
        input.setAttribute("aria-label", "Coupon code");
      }
    });

    if (!existingLabel) {
      const label = document.createElement("label");
      label.htmlFor = "cart-coupon-code";
      label.className = "docapp-coupon-label";
      label.textContent = "Coupon Code";

      couponInput.parentElement.insertBefore(label, couponInput);
    }
  }

  if (couponButton && couponButton.tagName !== "BUTTON") {
    couponButton.setAttribute("role", "button");
    couponButton.setAttribute("tabindex", "0");
    couponButton.setAttribute("aria-label", "Apply coupon");

    if (!couponButton.dataset.accessibilityEnhanced) {
      couponButton.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          couponButton.click();
        }
      });

      couponButton.dataset.accessibilityEnhanced = "true";
    }
  }
}

function initCouponAccessibility() {
  enhanceCouponAccessibility();

  const observer = new MutationObserver(() => {
    enhanceCouponAccessibility();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCouponAccessibility);
} else {
  initCouponAccessibility();
}
function asm_read_checkout_shipping_methods() {
  var checked_input = false;
  var form_tags = document.body.getElementsByTagName("form");
  for (i = 0; i < form_tags.length; i++) {
    if (form_tags[i].className.indexOf("edit_checkout") != -1) {
      var div_tags = form_tags[i].getElementsByTagName("div");
      for (x = 0; x < div_tags.length; x++) {
        if (div_tags[x].className == "radio-wrapper") {
          var input_tags = div_tags[x].getElementsByTagName("input");
          var span_tags = div_tags[x].getElementsByTagName("span");
          for (z = 0; z < span_tags.length; z++) {
            if (span_tags[z].attributes["data-shipping-method-label-title"]) {
              if (
                span_tags[z].attributes["data-shipping-method-label-title"]
                  .value == asm_selected_method
              ) {
                input_tags[0].click();
                checked_input = true;
                break;
              }
            }
          }
        }
        if (checked_input == true) break;
      }
    }
    if (checked_input == true) break;
  }
  if (checked_input == false)
    setTimeout("asm_read_checkout_shipping_methods()", 100);
}
var asm_store_data = "";
if (document.getElementById("shopify-features"))
  asm_store_data = JSON.parse(
    document.getElementById("shopify-features").innerHTML,
  );
else if (
  Shopify.Checkout.dynamicCheckoutPaymentInstrumentsConfig.paymentInstruments
    .checkoutConfig.domain
)
  asm_store_data =
    Shopify.Checkout.dynamicCheckoutPaymentInstrumentsConfig.paymentInstruments
      .checkoutConfig;
else asm_store_data.domain = "myshopify.com";
var asm_cookie_domain = asm_store_data.domain;
var asm_cart_subtotal;
var asm_total_discount = 0;
var asm_cart_total;
var asm_cart_weight_lb;
var asm_fake_standard_rate;
var auto_calc = true;
var asm_insurance = 0;
var asm_existing_insurance = 0;
var asm_existing_insurance_variant_id;
var asm_ajax_counter = 0;
var asm_selected_method;

if (sessionStorage.getItem("ASM-Selected-Method"))
  asm_selected_method = sessionStorage.getItem("ASM-Selected-Method");
asm_read_cart_data();

// trigger pricing update on page load and discount applied
document.body.addEventListener("docapp-discount-applied", (e) => {
  asm_total_discount = e.cart.total_discount;
  asm_calc_totals();
});

document.body.addEventListener("docapp-discount-success", (e) => {
  asm_calc_totals();
});
